<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header" :class="{ 'modal-header-named' : selectedCompany !== undefined }">
        <div class="new-input" v-if="selectedCompany === undefined">
          <span class="miv">N</span>
          <input type="text" placeholder="Търсене" v-model="searchCompanies">
        </div>
        <h1 v-else>
          <span class="miv2" @click="selectedCompany = undefined">K</span>
          {{companies[selectedCompany].companyName}}
        </h1>
        <span class="miv modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content" v-if="selectedCompany === undefined">
        <p class="category-p" v-if="!searchCompanies && latestFilteredCompanies.length">Последно активни проекти</p>
          <div
            class="modal-content-item"
            v-for="(c) in latestFilteredCompanies"
            :key="`addCompaniesModal-last-${c._id}`"
            @click="selectCompany(c._id)"
          >
            <span class="miv2">C</span>
            {{c.companyName}}
          </div>
        <p class="category-p" v-if="!searchCompanies">Всички проекти</p>
        <div
          class="modal-content-item"
          v-for="(c) in filteredCompanies"
          v-show="!c.hide"
          :key="`addCompaniesModal-${c._id}`"
          @click="selectCompany(c._id)"
        >
          <span class="miv2">C</span>
          {{c.companyName}}
        </div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="!filteredCompanies.length">
          Няма намерени резултати за '
          <strong>{{this.searchCompanies}}</strong>'
        </p>
      </div>
      <div class="modal-content" v-else>
        <ul class="projects-ul-wrapper">
          <!-- ПРОЕКТИ -->
          <li
            v-for="p in companies[selectedCompany].projects"
            :key="p._id"
            class="project-li"
            :ref="p._id"
          >
            <div class="project-toggle" @click="toggleProject(p._id)">
              <span class="miv">M</span>
              <span>
                <strong>ПРОЕКТ:</strong>
                {{p.projectName}}
              </span>
            </div>
            <!-- ОБЕКТИ -->
            <ul class="objects-ul-wrapper">
              <li v-for="o in p.objects" :key="o._id" class="object-li" :ref="o._id">
                <div class="object-toggle" @click="selectProjectAndObject(p._id, o._id)">
                  <span>
                    <strong>ОБЕКТ:</strong>
                    {{o.objectName}}
                  </span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- <div class="modal-footer" v-if="selectedCompany !== undefined">
        <button class="btn btn-new" @click="save()">
          <span class="miv">Y</span>
          Запази
        </button>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      companies: [],
      latestCompanies: [],
      searchCompanies: "",
      selectedCompany: undefined,
      company: {
        companyId: "",
        projectId: "",
        objectId: ""
      }
    };
  },
  computed: {
    filteredCompanies() {
      return this.filterCompanies();
    },
    latestFilteredCompanies() {
      return this.filterLatestCompanies();
    },
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser"
      // ...
    ])
  },
  methods: {
    toggleProject(id) {
      const parentElement = this.$refs[id][0];
      const selectedChildren = parentElement.getElementsByClassName(
        "object-toggle"
      );
      if (selectedChildren) {
        // Close
        if (parentElement.classList.contains("project-li-active")) {
          for (let i = 0; i < selectedChildren.length; i++) {
            selectedChildren[i].classList.remove("object-toggle-active");
          }
          parentElement.classList.remove("project-li-active");
        } else {
          // Open
          for (let i = 0; i < selectedChildren.length; i++) {
            selectedChildren[i].classList.add("object-toggle-active");
          }
          parentElement.classList.add("project-li-active");
        }
      }
    },
    getAllCompanies() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/company/active`)
        .then(response => {
          this.companies = response.data;
          this.getLatestUsedCompanies();
        });
    },
    getLatestUsedCompanies() {
      const id = this.getUser._id;
      const url = `${process.env.VUE_APP_BASE_URI}/report/limited/${id}/9`;
      this.$http
        .get(url)
        .then(response => {
          this.latestCompanies = response.data;
          this.latestCompanies.map((lc) => {
            const i = this.companies.map((c) => { return c._id; }).indexOf(lc._id);
            this.companies[i].hide = true;
          });
        })
        .catch(error => console.log(error));
    },
    filterCompanies() {
      return this.companies.filter(c => {
        return c.companyName
          .toLowerCase()
          .includes(this.searchCompanies.toLowerCase());
      });
    },
    filterLatestCompanies() {
      return this.latestCompanies.filter(c => {
        return c.companyName
          .toLowerCase()
          .includes(this.searchCompanies.toLowerCase());
      });
    },
    selectCompany(id) {
      this.selectedCompany = this.companies.findIndex(c => c._id === id);
      this.company.companyId = this.companies[this.selectedCompany]._id;
    },
    selectProjectAndObject(p, o) {
      this.company.projectId = p;
      this.company.objectId = o;
      this.save();
    },
    close() {
      this.$parent.$emit("closeAddCompaniesModal");
    },
    save() {
      if (this.company.objectId.length) {
        this.$parent.$emit("saveAddCompaniesModal", this.company);
      } else {
        this.$snotify.error("Не сте избрали обект!");
      }
    }
  },
  mounted() {
    this.getAllCompanies();
  }
};
</script>

<style scoped>
.modal-header-named {
  justify-content: flex-start;
}
.modal-header-named h1 {
  color: #fff;
  font-size: 20px;
  padding: 0 20px;
}
.modal-header-named h1 .miv2 {
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  margin-right: 10px;
  padding: 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.modal-header-named h1 .miv2:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.modal-content-item {
  cursor: pointer;
  padding-left: 30px;
  padding-right: 10px;
  width: calc(33.33% - 20px);
}
.modal-content-item .miv2 {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.modal-footer {
  justify-content: center;
}
/* DROPDOWNS */
/* PROJECTS */
.project-li {
  background-color: #fff;
  border-radius: 4px;
  display: block;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.project-li-inactive {
  background-color: #fff8f8;
}
.project-toggle {
  align-items: center;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  padding: 7px 10px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.project-toggle-inactive {
  background-color: #fff8f8;
}
.project-toggle:hover {
  color: rgba(0, 0, 0, 0.8);
}
.project-toggle > .miv {
  margin: 0 7px 0 4px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
/* OBJECTS */
.objects-ul-wrapper {
  padding-left: 50px;
}
.object-toggle {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 0;
  overflow: hidden;
  padding: 0 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.object-toggle:hover {
  color: rgba(0, 0, 0, 0.8);
}
.object-toggle-active {
  border-radius: 4px;
  height: 25px;
}
.object-toggle-active:hover {
  background-color: #d3dae2;
}
.object-toggle > .miv {
  margin-right: 7px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.project-li-active .project-toggle .miv {
  transform: rotate(90deg);
}
/* FIX TEXTS OVERFLOW */
.project-li span:nth-child(2),
.object-li span:nth-child(2) {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.category-p {
  font-weight: 700;
  margin: 15px 0;
  text-align: center;
  width: 100%;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-content-check {
    width: 45%;
  }
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
